export const DAY_IN_SECONDS = 86400;
export const DAY_IN_MILLISECONDS = 86400000;

export const COMPANY_LATITUDE = 3.0527830823665196;
export const COMPANY_LONGITUDE = 101.67106596466282;